var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../self-services.service.ts';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { UploadService } from './../d-i/upload.service';
import { DataService } from "src/app/bpg-common/services/data.services";
var NaacComponent = /** @class */ (function () {
    function NaacComponent(router, spinnerService, naacService, environment, bpgCommonService, uploadService, data) {
        this.router = router;
        this.spinnerService = spinnerService;
        this.naacService = naacService;
        this.environment = environment;
        this.bpgCommonService = bpgCommonService;
        this.uploadService = uploadService;
        this.data = data;
        this.editandSavebtn = false;
        this.savebtn = false;
        //Naac details Section
        this.naacDetailsSuccess = false;
        this.naacDetailsUpdate = false;
        this.naacDetailsCheck = false;
        this.selectedFileforBanner = null;
        this.uploadFileNameBanner = 'JPEG or PNG';
        this.naacBannerImage = '';
        this.isUploadBannerImage = false;
        this.isLoaderBannerStop = false;
        this.isbannerimageLoaded = false;
        this.bannerImageExtensionError = false;
        this.naacVision = null;
        this.naacAffinity = null;
        this.naacDetailsList = [];
        this.naacBannerId = 0;
        this.isLoaderNaacLogoStop = false;
        this.naacLogoImage = '';
        this.isUploadnaacLogoImage = false;
        this.uploadFileNamenaacLogo = null;
        this.uploadnaacLogoDone = false;
        this.uploadFileExtensionnaacLogo = false;
        this.selectedFileNameforNews = 'JPEG or PNG';
        this.naacNewsTable = false;
        this.noNewsTable = false;
        this.deleteNews = false;
        this.saveAndUpdateNews = false;
        this.saveNews = true;
        this.newsLinkValid = false;
        this.naacNewsSuccess = false;
        this.naacNewsId = 0;
        this.firstEditNews = true;
        this.uploadFileExtensionNewsImage = false;
        this.isUploadnewsImage = false;
        this.isLoadernewsImageStop = false;
        this.imageCheck = false;
        this.uploadFileNamenewsImage = null;
        this.uploadnewsImageDone = false;
        this.newsImageHeight = '';
        this.newsImageWidth = '';
        //resource section
        this.deleteResource = false;
        this.noResourceTable = false;
        this.naacResourceTable = false;
        this.additionalDesc = null;
        this.folderNameList = [];
        this.errorMessageResourceActive = false;
        this.naacResourceSuccess = false;
        this.firstEditResource = true;
        this.saveResource = true;
        this.saveAndUpdateResource = false;
        this.ResourcefileName = "Upload document(< 500MB)";
        this.fileSizeExtensionError = false;
        this.selectedFile = null;
        this.isuploaded = true;
        this.fileList = [];
        this.timeOutError = false;
        this.isFileUploded = false;
        this.uploadFileExtension = false;
        this.uploadFileExtensionUser = false;
        this.uploadImageDone = false;
        this.isLoaderStop = false;
        this.isUploadImage = false;
        this.reTeamEamilValid = false;
        this.saveReTeam = true;
        this.saveAndUpdateReTeam = false;
        this.errorMessageRegionalActive = false;
        this.firstEditReTeam = true;
        this.deleteRegional = false;
        this.noReginalTbale = false;
        this.uploadFileNameUser = null;
        this.naacReTeamTable = false;
        this.siteList = [];
        this.siteName = [];
        this.siteNameList = [];
        this.uploadUserPicImageDone = false;
        this.isLoaderUserPicStop = false;
        this.isUploadUserPicImage = false;
        this.naacUserImage = null;
        this.naacReteamSuccess = false;
        //dashboard section
        this.affinityList = [];
        this.affinityResponse = [];
        this.naacDate = null;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.errorAffinity = false;
        this.affinityTable = true;
        this.naacAffinityList = [];
        this.noAffinityTable = false;
        this.naacEdit = false;
        this.deleteAffinity = false;
        this.selectedNews = [];
        this.selectedReteam = [];
        this.selectedResource = [];
        this.naacPublishSuccess = false;
        this.LandingPaginationDTO = new LandingPaginationDTO();
        this.limit = ConstantValues.pageLimit;
        this.currentShowingElementsAffinity = ConstantValues.pageLimit;
        this.currentShowingElementsNews = ConstantValues.pageLimit;
        this.currentShowingElementsResource = ConstantValues.pageLimit;
        this.currentShowingElementsReTeam = ConstantValues.pageLimit;
        this.currentShowingElementsNaac = ConstantValues.pageLimit;
        this.deleteSuccess = false;
        this.currentPage = 1;
        this.showReset = false;
        this.saveMasterBtn = false;
        this.naacId = 0;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.failureOnResourceUpload = false;
        this.butDisabled = true;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.disableAffinity = false;
        //Image Cropper
        this.imageChangedEvent = '';
        this.imageChangedEventBanner = '';
        this.croppedImage = '';
        this.imageTypeName = null;
        this.isNewsPageClicked = false;
        this.isResourcePageClicked = false;
        this.isRegionalPageClicked = false;
        this.isNaacAdmin = false;
        this.removeToolbar = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' };
    }
    ;
    NaacComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
            if (localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        localStorage.removeItem('searchedEventsCaledarItems');
        this.adminId = localStorage.getItem('adminId');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        if (localStorage.getItem('isNaacAdmin') == 'true') {
            this.isNaacAdmin = true;
        }
        if (this.adminId != "1" && this.adminId != "4" && !this.isNaacAdmin) {
            this.router.navigate(['/site-home']);
        }
        // if (this.loginDetails == null) {
        //   this.router.navigate(['/login']);
        // }
        this.saveMasterBtn = true;
        this.getnaacBannerList();
        this.getallSite();
        this.getAllAffinity();
        this.getnaacnewsList();
        this.getnaacREteam();
        this.getNaacResouceList();
        this.getnaacAffinityList();
        this.getNaacFolderList();
        this.bpgCommonService.getSessionToken();
        this.imageChangedEvent = '';
        this.imageChangedEventBanner = '';
        this.croppedImage = '';
        this.uploadFileExtensionUser = false;
        document.getElementById("base64textareaUser").textContent = '';
        // document.getElementById("base64textareaBanner").textContent = '';
        document.getElementById("filenameUserPic").textContent = "JPEG or PNG";
        document.getElementById("filenamenaacLogo").textContent = "JPEG or PNG";
        document.getElementById("base64textareanaacLogo").textContent = '';
        document.getElementById("filenamenewsImage").textContent = "JPEG or PNG";
        document.getElementById("base64textareanewsImage").textContent = '';
        this.uploadFileExtensionnaacLogo = false;
        this.isUploadImage = false;
        this.isLoaderStop = false;
        this.naacUserImage = null;
        this.naacLogoImage = '';
        this.uploadImageDone = false;
        this.uploadUserPicImageDone = false;
        this.isLoaderUserPicStop = false;
        this.isUploadUserPicImage = false;
        this.isUploadBannerImage = false;
        this.isLoaderBannerStop = false;
        this.isLoaderNaacLogoStop = false;
        this.uploadnaacLogoDone = false;
        this.isUploadnaacLogoImage = false;
        this.isUploadnewsImage = false;
        this.isLoadernewsImageStop = false;
        this.uploadnewsImageDone = false;
        this.naacNewsImage = '';
        this.uploadFileExtensionNewsImage = false;
        this.data.folderSection.subscribe(function (myData) {
            _this.isFolderSectionClicked = myData;
        });
    };
    /** get all site list
       * @class allSite
       * @method   getallSite(){
    
       */
    NaacComponent.prototype.getallSite = function () {
        var _this = this;
        this.naacService.getAllSite().subscribe(function (data) {
            _this.siteList = data;
        });
    };
    /** get all affinity list
     * @class allAffinity
     * @method   getAllAffinity(){
  
     */
    NaacComponent.prototype.getAllAffinity = function () {
        var _this = this;
        var landingDto = {
            "filter": { "adminId": this.adminId,
                "userId": this.loginDetails.userId },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "",
            "uid": "",
        };
        this.naacService.getAllNaac(landingDto).subscribe(function (data) {
            _this.affinityList = data;
            if ((_this.adminId == "4" || _this.isNaacAdmin) && _this.affinityList[0].checkAffinity != null) {
                _this.disableAffinity = true;
            }
        });
    };
    /** get banner image list
     * @class BannerImage
     * @method getdiBannerList
     */
    NaacComponent.prototype.getnaacBannerList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO = {
            "filter": { "naacFlag": "naacSelfService" },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 50,
            "sortDirection": "ASC",
            "sortProperty": "naacId",
            "uid": ""
        };
        this.naacService.getnaacBannerList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.bannerResponseList = data.content;
            _this.deleteSuccess = false;
            _this.spinnerService.hide();
            _this.numberOfElements = data.totalElements;
            if (_this.bannerResponseList.length == 0)
                _this.noDataFound = true;
            else {
                _this.noDataFound = false;
            }
        });
    };
    /** to clear data
     * @class DIComponent
     * @method clearAlerts
     */
    NaacComponent.prototype.clearAlerts = function () {
        this.noUser = false;
        this.userFound = false;
    };
    /** to list users other than admins
    * @class naacComponent
    * @method getUserList
    */
    NaacComponent.prototype.getUserList = function () {
        var _this = this;
        this.naacReteamSuccess = false;
        this.deleteRegional = false;
        this.LandingPaginationDTO.filter = { "leadershipPosition": "USER" };
        this.naacService.getUserDropDown(this.LandingPaginationDTO).subscribe(function (data) {
            _this.userList = data;
            if (_this.userList.length == 0) {
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 500);
                _this.noUser = true;
                _this.userFirstName = null;
                _this.emailId = null;
                _this.butDisabled = true;
            }
            else {
                _this.butDisabled = false;
                if (_this.search) {
                    setTimeout(function () {
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 500);
                    _this.userFound = true;
                }
                _this.userList.map(function (i) { i.userFirstName = i.userFirstName + ' ' + i.userLastName; return i; });
            }
        }, function (err) {
            console.log(JSON.stringify(err.value.message));
        });
    };
    /** to select the user acc to search
    * @class naacComponent
    * @method userSelection
    */
    NaacComponent.prototype.userSelection = function (user) {
        this.userFound = false;
        for (var i = 0; i < this.userList.length; i++) {
            if (this.userList[i] != null) {
                if (user.userId == this.userList[i].userId) {
                    this.userId = this.userList[i].userId;
                    this.name = this.userList[i].userFirstName;
                    this.emailId = this.userList[i].emailId;
                    // this.workId = this.userList[i].workdayId;
                    this.reTeamEamilValid = false;
                }
            }
        }
    };
    /** to sumbit naac master
    * @class naacComponent
    * @method onNaacMasterSubmit
    */
    NaacComponent.prototype.onNaacMasterSubmit = function () {
        if (this.uploadFileExtension == true) {
            this.removeModal();
            return;
        }
        if (this.saveMasterBtn == true) {
            this.setModal();
            this.popupModal();
            document.getElementById('masterSave').click();
        }
    };
    NaacComponent.prototype.popupModal = function () {
        this.method = "saveMaster";
        this.param = '';
        this.msg1 = " Are you sure you want to update ? ";
    };
    NaacComponent.prototype.setModal = function () {
        document.getElementById('masterSave').setAttribute('data-toggle', 'modal');
        document.getElementById('masterSave').setAttribute('data-target', '#myModal');
    };
    NaacComponent.prototype.removeModal = function () {
        document.getElementById('masterSave').removeAttribute('data-toggle');
        document.getElementById('masterSave').removeAttribute('data-target');
    };
    /** to submit Dashboard Details
     * @class NaacComponent
     * @method onDashboardSubmit
     */
    NaacComponent.prototype.onDashboardSubmit = function (status) {
        if (status == 'Draft') {
            this.method = "addDashboard";
            this.param = status;
            this.msg1 = " Are you sure you want to save ? ";
        }
        else {
            this.method = "addDashboard";
            this.param = status;
            this.msg1 = " Are you sure you want to publish NAAC ? ";
        }
    };
    /** to save/update dashboard
    * @class NaacComponent
    * @method addDashboard
    */
    NaacComponent.prototype.addDashboard = function (status) {
        var _this = this;
        if (status == 'Draft') {
            this.naacStatus = null;
        }
        else {
            this.naacStatus = 'Publish';
        }
        this.spinnerService.show();
        for (var i = 0; i < this.affinityList.length; i++) {
            if (this.affinityList[i].bpgId == this.selectedBpg) {
                var selectedbpgName = this.affinityList[i].bpgName;
                break;
            }
        }
        var affinityData = {
            "naacId": this.naacId,
            "naacAffinityId": this.selectedBpg,
            "id": this.loginDetails.userId,
            "naacDate": this.naacDate,
            "naacAffinityName": selectedbpgName,
            "naacStatus": this.naacStatus
        };
        this.naacService.naacAddAffinity(affinityData).subscribe(function (data) {
            if (data.message != null) {
                _this.affinityErrorMsg = data.message;
                _this.errorAffinity = true;
                _this.getnaacAffinityList();
            }
            else if (data.naacStatus == "Draft") {
                if (_this.naacEdit == true) {
                    _this.affinitySuccess = false;
                    _this.affinityUpdate = true;
                }
                else {
                    _this.affinitySuccess = true;
                    _this.affinityUpdate = false;
                }
                _this.errorAffinity = false;
                _this.naacId = data.naacId;
                localStorage.setItem("naacId", _this.naacId);
                _this.deleteAffinity = false;
                _this.getnaacAffinityList();
            }
            else if (data.naacStatus == "Publish") {
                _this.naacPublishSuccess = true;
                _this.naacDetailsUpdate = false;
                _this.naacDetailsSuccess = false;
                _this.naacNewsSuccess = false;
                _this.naacResourceSuccess = false;
                _this.naacReteamSuccess = false;
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    NaacComponent.prototype.onPublishNaac = function (data) {
        this.method = "publishNaac";
        this.param = data;
        this.msg1 = " Are you sure you want to publish NAAC ? ";
    };
    NaacComponent.prototype.publishNaac = function (data) {
        var _this = this;
        this.spinnerService.show();
        var affinityData = {
            "naacId": data.naacId,
            "naacAffinityId": data.naacAffinityId,
            "id": this.loginDetails.userId,
            "naacDate": data.naacDate,
            "naacAffinityName": data.naacAffinityName,
            "naacStatus": 'Publish'
        };
        this.naacService.naacAddAffinity(affinityData).subscribe(function (data) {
            if (data.message != null) {
                _this.affinityErrorMsg = data.message;
                _this.errorAffinity = true;
            }
            else {
                _this.naacPublishSuccess = true;
                _this.getnaacAffinityList();
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to submit news
    * @class DIComponent
    * @method onNewsSubmit
    */
    NaacComponent.prototype.onNewsSubmit = function () {
        if (this.saveAndUpdateNews == true) {
            this.method = "addNews";
            this.param = '';
            this.msg1 = " Are you sure you want to update ? ";
        }
        else {
            this.method = "addNews";
            this.param = '';
            this.msg1 = " Are you sure you want to Save ? ";
        }
    };
    /** to save/update news
    * @class DIComponent
    * @method addNews
    */
    NaacComponent.prototype.addNews = function () {
        var _this = this;
        this.spinnerService.show();
        if (this.uploadFileNamenewsImage != null && this.uploadFileNamenewsImage != undefined && this.uploadFileNamenewsImage != '')
            this.imageCheck = true;
        if (!this.saveAndUpdateNews)
            this.newsId = 0;
        var newsData = {
            "naacNewsTitle": this.newsTitle,
            "naacNewsDesc": this.newsDesc,
            "naacNewsLink": this.newsLink,
            "id": this.loginDetails.userId,
            "newsImage": this.uploadFileNamenewsImage,
            "naacImageCheck": this.imageCheck,
            "naacNewsId": this.newsId,
            "naacId": this.naacId,
            "naacNewsImage": this.naacNewsImage
        };
        this.naacService.addnaacNews(newsData).subscribe(function (data) {
            if (data != undefined) {
                _this.deleteNews = false;
                _this.naacNewsSuccess = true;
                _this.getnaacnewsList();
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to submit resource
   * @class NaacComponent
   * @method onResourceSubmit
   */
    NaacComponent.prototype.onResourceSubmit = function () {
        if (this.saveAndUpdateResource == true) {
            this.method = "addResource";
            this.param = '';
            this.msg1 = " Are you sure you want to update ? ";
        }
        else {
            this.naacResourceId = 0;
            this.method = "addResource";
            this.param = '';
            this.msg1 = " Are you sure you want to Save ? ";
        }
    };
    /** to submit resource
    * @class NaacComponent
    * @method onResourceSubmit
    */
    NaacComponent.prototype.onNaacMasterSubmitBanner = function () {
        this.method = "addBanner";
        this.param = '';
        this.msg1 = " Are you sure you want to save ? ";
    };
    NaacComponent.prototype.addBanner = function () {
        var _this = this;
        var bannerData = {
            "naacId": this.naacId,
            "id": this.loginDetails.userId,
            "naacBanner": this.uploadFileNameBanner,
            "naacBannerImage": this.naacBannerImage,
            "naacVision": this.naacVision,
            "naacAffinity": this.naacAffinity,
            "naacBannerId": this.naacBannerId,
            "naacLogo": this.uploadFileNamenaacLogo,
            "naacLogoImage": this.naacLogoImage
        };
        this.spinnerService.show();
        this.naacService.addnaacMaster(bannerData).subscribe(function (response) {
            if (response.body.message == 'Error') {
                _this.errorMsgUploadSave = true;
            }
            else if (_this.naacEdit == true) {
                _this.naacDetailsUpdate = true;
                _this.naacDetailsSuccess = false;
            }
            else {
                _this.naacDetailsSuccess = true;
                _this.naacDetailsUpdate = false;
            }
            _this.getnaacBannerList();
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to save/update resource
    * @class NaacComponent
    * @method addResource
    */
    NaacComponent.prototype.addResource = function () {
        var _this = this;
        this.spinnerService.show();
        var uploadData = {
            'category': 'uploadDocument',
        };
        this.uploadFlag = 'naacResource';
        var ResourceData = {
            "naacResourceId": this.naacResourceId,
            "naacId": this.naacId,
            "naacResourceTitle": this.addResouceTitle,
            "naacResourceDesc": this.additionalDesc,
            "naacResourceDocument": this.UploadDocument,
            "id": this.loginDetails.userId,
            "resourceOrder": this.resourceOrder,
            "folderId": this.selectedFolder
        };
        //for edit case
        if (this.saveAndUpdateResource == true) {
            if (this.selectedFile != null) {
                this.spinnerService.show();
                this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.awsUrls = data;
                                return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.naacResourceId, this.uploadFlag)];
                            case 1:
                                _a.sent();
                                console.log("errorUpl" + localStorage.getItem('uploadError'));
                                if (localStorage.getItem('uploadError') == 'Error') {
                                    this.errorMessageResourceActive = false;
                                    this.errorMsgUploadSaveUpdate = true;
                                    this.naacResourceSuccess = false;
                                    this.getNaacResouceList();
                                    this.getNaacFolderList();
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinnerService.hide();
                                    localStorage.removeItem('uploadError');
                                }
                                else {
                                    this.naacService.addnaacResource(ResourceData).subscribe(function (data) {
                                        _this.resourceData = data;
                                        _this.uploadFlag = 'naacResource';
                                        if (data.message != undefined) {
                                            _this.errorMessageResource = data.message;
                                            _this.errorMessageResourceActive = true;
                                            _this.errorMsgUploadSaveUpdate = false;
                                            _this.naacResourceSuccess = false;
                                            setTimeout(function () {
                                                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                            }, 200);
                                        }
                                        else if (data != undefined) {
                                            _this.spinnerService.show();
                                            _this.errorMessageResourceActive = false;
                                            _this.naacResourceSuccess = true;
                                            _this.deleteResource = false;
                                            _this.errorMsgUploadSaveUpdate = false;
                                            _this.getNaacResouceList();
                                            _this.getNaacFolderList();
                                            _this.spinnerService.hide();
                                            setTimeout(function () {
                                                _this.onResetResourceClick();
                                            }, 3000);
                                        }
                                    });
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
            else {
                //edit no files selected
                this.spinnerService.show();
                this.naacService.addnaacResource(ResourceData).subscribe(function (data) {
                    if (data.message != undefined) {
                        _this.errorMessageResource = data.message;
                        _this.errorMessageResourceActive = true;
                        _this.naacResourceSuccess = false;
                        _this.spinnerService.hide();
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    }
                    else if (data != undefined) {
                        _this.errorMessageResourceActive = false;
                        _this.naacResourceSuccess = true;
                        _this.deleteResource = false;
                        //this.onResetResourceClick();
                        _this.getNaacResouceList();
                        _this.getNaacFolderList();
                        setTimeout(function () {
                            _this.onResetResourceClick();
                        }, 3000);
                        _this.spinnerService.hide();
                    }
                });
            }
        }
        //if save condition
        else {
            this.spinnerService.show();
            this.naacService.addnaacResource(ResourceData).subscribe(function (data) {
                _this.resourceData = data;
                if (data.message != undefined) {
                    _this.errorMessageResource = data.message;
                    _this.errorMessageResourceActive = true;
                    _this.naacResourceSuccess = false;
                    _this.deleteResource = false;
                    _this.spinnerService.hide();
                    setTimeout(function () {
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 300);
                }
                else if (data != undefined) {
                    _this.spinnerService.show();
                    _this.uploadFlag = 'naacResource';
                    if (_this.selectedFile != null) {
                        _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var dleteData;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.awsUrls = data;
                                        return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.resourceData.naacResourceId, this.uploadFlag)];
                                    case 1:
                                        _a.sent();
                                        //this.error = JSON.parse(localStorage.getItem('UploadError'));
                                        console.log("errorUpl" + localStorage.getItem('uploadError'));
                                        if (localStorage.getItem('uploadError') == 'Error') {
                                            dleteData = {
                                                "id": this.resourceData.naacResourceId,
                                                "flag": "resource"
                                            };
                                            this.naacService.deletenaac(dleteData).subscribe(function (data) {
                                                if (data.flag == "resource") {
                                                    _this.errorMessageResourceActive = false;
                                                    _this.errorMsgUploadSave = true;
                                                    _this.naacResourceSuccess = false;
                                                    _this.getNaacResouceList();
                                                    _this.getNaacFolderList();
                                                    setTimeout(function () {
                                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                                    }, 200);
                                                }
                                            });
                                            this.spinnerService.hide();
                                            localStorage.removeItem('uploadError');
                                        }
                                        else {
                                            this.errorMessageResourceActive = false;
                                            this.naacResourceSuccess = true;
                                            this.deleteResource = false;
                                            this.errorMsgUploadSave = false;
                                            // this.onResetResourceClick();
                                            this.getNaacResouceList();
                                            this.getNaacFolderList();
                                            setTimeout(function () {
                                                _this.onResetResourceClick();
                                            }, 3000);
                                        }
                                        this.spinnerService.hide();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                }
            });
        }
    };
    /** to submit ReTeam
   * @class NaacComponent
   * @method onReTeamSubmit
   */
    NaacComponent.prototype.onReTeamSubmit = function () {
        if (this.uploadFileExtensionUser == true) {
            this.removeModalReTeam();
            return;
        }
        if (this.saveAndUpdateReTeam == true) {
            this.setModalReTeam();
            this.popupModalReTeam();
            document.getElementById('UpdateReTeam').click();
        }
        else {
            this.setModalReTeam();
            this.popupModalReTeam();
            document.getElementById('saveReTeam').click();
        }
    };
    NaacComponent.prototype.popupModalReTeam = function () {
        if (this.saveAndUpdateReTeam == true) {
            this.method = "addReTeam";
            this.param = '';
            this.msg1 = " Are you sure you want to update ? ";
        }
        else {
            this.method = "addReTeam";
            this.param = '';
            this.msg1 = " Are you sure you want to Save ? ";
        }
    };
    NaacComponent.prototype.setModalReTeam = function () {
        if (this.saveAndUpdateReTeam == true) {
            document.getElementById('UpdateReTeam').setAttribute('data-toggle', 'modal');
            document.getElementById('UpdateReTeam').setAttribute('data-target', '#myModal');
        }
        else {
            document.getElementById('saveReTeam').setAttribute('data-toggle', 'modal');
            document.getElementById('saveReTeam').setAttribute('data-target', '#myModal');
        }
    };
    NaacComponent.prototype.removeModalReTeam = function () {
        if (this.saveAndUpdateReTeam == true) {
            document.getElementById('UpdateReTeam').removeAttribute('data-toggle');
            document.getElementById('UpdateReTeam').removeAttribute('data-target');
        }
        else {
            document.getElementById('saveReTeam').removeAttribute('data-toggle');
            document.getElementById('saveReTeam').removeAttribute('data-target');
        }
    };
    /** to reset news
     * @class NaacComponent
     * @method resetNews
     */
    NaacComponent.prototype.navigateNaacFolder = function () {
        this.clearAlerts();
        this.method = "navigateNaacFolderClick";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.navigateNaacFolderClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.router.navigate(['/naac-folder']);
    };
    /** to save/edit reTeam
   * @class NaacComponent
   * @method addReTeam
   */
    NaacComponent.prototype.addReTeam = function () {
        var _this = this;
        if (this.saveAndUpdateReTeam == true) {
            this.reTeamFlag = "updateReTeam";
        }
        else {
            this.reTeamFlag = "saveReTeam";
            this.naacReTeamId = '0';
        }
        this.siteNameList = [];
        if (this.siteName.length > 0) {
            for (var i = 0; i < this.siteName.length; i++) {
                if (this.siteName[i].siteName != null && this.siteName[i].siteName != undefined)
                    this.siteNameList.push(this.siteName[i].siteName);
                else
                    this.siteNameList.push(this.siteName[i]);
            }
        }
        this.spinnerService.show();
        this.naacUserImage = document.getElementById("base64textareaUser").textContent;
        var userData = {
            "id": this.loginDetails.userId,
            "userId": this.userId,
            "naacId": this.naacId,
            "roleName": this.regionalDesignation,
            "emailId": this.emailId,
            "userPic": this.uploadFileNameUser,
            "reTeamPic": this.naacUserImage,
            "regionalOrder": this.reTeamOrder,
            "siteNameList": this.siteNameList,
            "naacPronounce": this.naacPronoun,
            "naacReTeamId": this.naacReTeamId,
            "reTeamFlag": this.reTeamFlag,
        };
        //(userData)
        this.naacService.addnaacReTeam(userData).subscribe(function (data) {
            if (data.message != undefined) {
                _this.errorMessageRegional = data.message;
                _this.errorMessageRegionalActive = true;
                _this.naacReteamSuccess = false;
                _this.noUser = false;
                _this.userFound = false;
            }
            else if (data != undefined) {
                _this.errorMessageRegionalActive = false;
                _this.noUser = false;
                _this.userFound = false;
                _this.naacReteamSuccess = true;
                _this.deleteRegional = false;
                _this.LandingPaginationDTO.searchTerm = '';
                _this.getnaacREteam();
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to reset Dashboard
     * @class NaacComponent
     * @method resetDashboard
     */
    NaacComponent.prototype.resetDashboard = function () {
        this.naacDate = null;
        this.selectedBpg = null;
        document.getElementById("bpgName").removeAttribute("disabled");
    };
    /** to reset news
       * @class NaacComponent
       * @method resetNews
       */
    NaacComponent.prototype.resetNews = function () {
        this.clearAlerts();
        this.method = "onResetNewsClick";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.onResetNewsClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteNews = false;
        this.deleteResetNews();
        this.getnaacnewsList();
    };
    NaacComponent.prototype.deleteResetNews = function () {
        this.naacNewsSuccess = false;
        this.newsId = null;
        this.newsTitle = null;
        this.newsDesc = null;
        this.newsLink = null;
        this.newsSearchKey = null;
        this.saveNews = true;
        this.firstEditNews = true;
        this.saveAndUpdateNews = false;
        this.newsLinkValid = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.isUploadnewsImage = false;
        document.getElementById("filenamenewsImage").textContent = "JPEG or PNG";
        document.getElementById("base64textareanewsImage").textContent = '';
        this.uploadFileNamenewsImage = null;
        this.naacNewsImage = '';
    };
    // to delete naac details
    NaacComponent.prototype.resetnaacDetails = function () {
        this.clearAlerts();
        this.method = "onResetnaacDetails";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.onResetnaacDetails = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteNews = false;
        this.deletenaacDetails();
    };
    NaacComponent.prototype.deletenaacDetails = function () {
        this.naacAffinity = null;
        this.naacVision = null;
        this.uploadFileNameBanner = '';
        this.naacBannerImage = '';
        this.isbannerimageLoaded = false;
        this.bannerImageExtensionError = false;
        this.selectedFileforBanner = null;
        this.uploadFileNameBanner = 'JPEG or PNG';
        this.isUploadBannerImage = false;
        this.isLoaderBannerStop = false;
        this.isbannerimageLoaded = false;
        this.deleteSuccess = false;
        this.naacDetailsSuccess = false;
        this.naacDetailsUpdate = false;
        this.naacLogoImage = '';
        this.uploadFileNamenaacLogo = null;
        document.getElementById("base64textareanaacLogo").textContent = '';
        document.getElementById("filenamenaacLogo").textContent = "JPEG or PNG";
    };
    /** to reset resource
     * @class NaacComponent
     * @method resetResource
     */
    NaacComponent.prototype.resetResource = function () {
        this.clearAlerts();
        this.method = "onResetResourceClick";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.onResetResourceClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteResource = false;
        this.deleteResetResource();
        this.getNaacResouceList();
        this.getNaacFolderList();
    };
    NaacComponent.prototype.deleteResetResource = function () {
        this.addResouceTitle = null;
        this.additionalDesc = null;
        this.addResourceDocument = null;
        this.resourceOrder = null;
        this.resourceSearchKey = null;
        this.LandingPaginationDTO.searchTerm = '';
        this.naacResourceSuccess = false;
        this.naacResourceId = '0';
        this.saveAndUpdateResource = false;
        this.saveResource = true;
        this.errorMessageResourceActive = false;
        this.ResourcefileName = "Upload document(< 500MB)";
        this.isFileUploded = false;
        this.selectedFile = null;
        this.fileSizeExtensionError = false;
        this.UploadDocument = null;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.selectedFolder = null;
        this.folderName = '';
        this.folderId = null;
    };
    /** to reset reTeam
     * @class NaacComponent
     * @method resetReTeam
     */
    NaacComponent.prototype.resetReTeam = function () {
        this.clearAlerts();
        this.method = "onResetReTeamClick";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.onResetReTeamClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteRegional = false;
        this.myInputVariable.nativeElement.value = "";
        this.deleteResetReTeam();
        this.getnaacREteam();
        this.imageChangedEvent = '';
        this.croppedImage = '';
        //this.uploadFileName = '';
        this.uploadFileExtensionUser = false;
        document.getElementById("base64textareaUser").textContent = '';
        document.getElementById("filenameUserPic").textContent = "JPEG or PNG";
        this.myInputVariable.nativeElement.value = '';
        this.isUploadImage = false;
        this.isLoaderStop = false;
        this.naacUserImage = null;
    };
    NaacComponent.prototype.deleteResetReTeam = function () {
        this.userList = null;
        this.regionalDesignation = null;
        this.userId = null;
        this.userFirstName = null;
        this.searchTerm = null;
        this.emailId = null;
        this.userPic = null;
        this.reTeamOrder = null;
        this.reTeamSearchKey = null;
        this.LandingPaginationDTO.searchTerm = '';
        this.naacReteamSuccess = false;
        this.naacUserImage = null;
        this.naacReTeamId = '0';
        this.reTeamEamilValid = false;
        this.uploadFileExtensionUser = false;
        this.errorMessageRegionalActive = false;
        this.naacPronoun = '';
        if (this.lbl != undefined) {
            this.lbl.innerText = "JPEG or PNG (400 x 200)";
        }
        document.getElementById("base64textareaUser").textContent = '';
        document.getElementById("filenameUserPic").textContent = "JPEG or PNG";
        this.saveReTeam = true;
        this.saveAndUpdateReTeam = false;
        this.butDisabled = true;
    };
    /** action on click of naac master tab
    * @class NaacComponent
    * @method naacMaster
    */
    NaacComponent.prototype.naacMaster = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.isNewsPageClicked = false;
        this.isResourcePageClicked = false;
        this.isRegionalPageClicked = false;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.errorAffinity = false;
        this.affinityTable = true;
        this.deleteAffinity = false;
        this.naacPublishSuccess = false;
        this.naacDetailsUpdate = false;
        this.naacNewsTable = false;
        this.naacResourceTable = false;
        this.naacReTeamTable = false;
        //this.affinityTable = true;
        // this.noNewsTable = false;
        // this.noResourceTable = false;
        // this.noReginalTbale = false;
        this.naacNewsSuccess = false;
        this.naacResourceSuccess = false;
        this.naacReteamSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.userFound = false;
        this.noUser = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.searchTerm = '';
        this.currentPage = 1;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.getnaacAffinityList();
    };
    /** action on click of naac news tab
   * @class NaacComponent
   * @method naacMaster
   */
    NaacComponent.prototype.naacNews = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.isNewsPageClicked = true;
        this.isResourcePageClicked = false;
        this.isRegionalPageClicked = false;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.errorAffinity = false;
        this.deleteAffinity = false;
        this.naacPublishSuccess = false;
        this.naacDetailsUpdate = false;
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.naacNewsTable = true;
        this.naacResourceTable = false;
        this.naacReTeamTable = false;
        this.affinityTable = false;
        // this.noResourceTable = false;
        // this.noReginalTbale = false;
        // this.noAffinityTable= false;
        this.naacDetailsUpdate = false;
        this.naacDetailsSuccess = false;
        this.naacNewsSuccess = false;
        this.naacReteamSuccess = false;
        this.naacResourceSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.userFound = false;
        this.noUser = false;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        //this.getnaacnewsList();
    };
    /** get list of naac affinity
  * @class NaacComponent
  * @method getnaacAffinityList
  */
    NaacComponent.prototype.getnaacAffinityList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        var LandingPaginationDTO = {
            "filter": { "naacFlag": "naacSelfService",
                "adminId": this.adminId,
                "userId": this.loginDetails.userId
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 500,
            "sortDirection": "ASC",
            "sortProperty": "naacId",
            "uid": "",
        };
        this.naacService.getnaacAffinityList(LandingPaginationDTO).subscribe(function (data) {
            _this.naacAffinityList = data;
            if (_this.naacAffinityList.length > 0) {
                for (var i = 0; i < _this.naacAffinityList.length; i++) {
                    if (localStorage.getItem("naacId") == _this.naacAffinityList[i].naacId && _this.isFolderSectionClicked == true) {
                        _this.onEditNaacClick(_this.naacAffinityList[i]);
                        break;
                    }
                }
            }
            if (_this.naacAffinityList.length == 0) {
                _this.noAffinityTable = true;
            }
            else {
                _this.noAffinityTable = false;
            }
            _this.numberOfElements = _this.naacAffinityList.length;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsAffinity = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsAffinity = _this.numberOfElements;
            }
        });
    };
    /** get list of naac news
    * @class NaacComponent
    * @method getnaacnewsList
    */
    NaacComponent.prototype.getnaacnewsList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO = {
            "filter": { "naacFlag": "naacSelfService" },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": this.newsSearchKey,
            "size": 500,
            "sortDirection": "ASC",
            "sortProperty": "modifiedDateTime",
            "uid": ""
        };
        this.naacService.getnaacnewsList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.naacNewsList = data.content;
            //(this.naacNewsList)
            if (_this.naacNewsList.length == 0) {
                _this.noNewsTable = true;
                //this.getnaacnewsList();
            }
            else {
                _this.noNewsTable = false;
                _this.tableShow = true;
                _this.selectedNews = [];
                for (var i = 0; i < _this.naacNewsList.length; i++) {
                    if (_this.naacId == _this.naacNewsList[i].naacId) {
                        _this.selectedNews.push(_this.naacNewsList[i]);
                        if (_this.selectedNews.length == 0) {
                            _this.noNewsTable = true;
                        }
                    }
                }
            }
            _this.numberOfElements = _this.selectedNews.length;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsNews = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsNews = _this.numberOfElements;
            }
        });
    };
    /** action on click of Naac resource tab
    * @class NaacComponent
    * @method naacResource
    */
    NaacComponent.prototype.naacResource = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.isNewsPageClicked = false;
        this.isResourcePageClicked = true;
        this.isRegionalPageClicked = false;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.errorAffinity = false;
        this.deleteAffinity = false;
        this.naacPublishSuccess = false;
        this.naacDetailsUpdate = false;
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.naacNewsTable = false;
        this.naacResourceTable = true;
        this.naacReTeamTable = false;
        this.affinityTable = false;
        // this.noNewsTable = false
        // this.noReginalTbale = false;
        // this.noAffinityTable = false;
        this.naacDetailsSuccess = false;
        this.naacNewsSuccess = false;
        this.naacReteamSuccess = false;
        this.naacDetailsUpdate = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.userFound = false;
        this.noUser = false;
        this.errorMessageRegionalActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.searchTerm = '';
        this.getNaacResouceList();
        this.getNaacFolderList();
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
    };
    /** get list of naac resource
    * @class NaacComponent
    * @method getNaacResouceList
    */
    NaacComponent.prototype.getNaacResouceList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO = {
            "filter": { "naacFlag": "naacSelfService" },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": this.resourceSearchKey,
            "size": 500,
            "sortDirection": "ASC",
            "sortProperty": "folderOrder",
            "uid": ""
        };
        this.naacService.getnaacResource(this.LandingPaginationDTO).subscribe(function (data) {
            _this.naacResouceList = data.content;
            if (_this.naacResouceList.length == 0) {
                _this.noResourceTable = true;
            }
            else {
                _this.selectedResource = [];
                _this.noResourceTable = false;
                _this.tableShow = true;
                for (var z = 0; z < _this.naacResouceList.length; z++) {
                    if (_this.naacId == _this.naacResouceList[z].naacId) {
                        _this.selectedResource.push(_this.naacResouceList[z]);
                    }
                }
                if (_this.selectedResource.length == 0) {
                    _this.noResourceTable = true;
                }
            }
            _this.numberOfElements = _this.selectedResource.length;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsResource = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsResource = _this.numberOfElements;
            }
        });
    };
    /** get list of naac Folders
  * @class NaacComponent
  * @method getNaacFolderList
  */
    NaacComponent.prototype.getNaacFolderList = function () {
        var _this = this;
        this.landingData = {
            "filter": {},
            "moduleId": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 50,
            "sortDirection": "DESC",
            "sortProperty": "created_date_time",
            "uid": ""
        };
        this.naacService.getNaacDocumentsFolder(this.landingData).subscribe(function (data) {
            var folderNameList = data.content;
            _this.folderNameList = [];
            for (var i = 0; i < folderNameList.length; i++) {
                if (folderNameList[i].naacId == _this.naacId) {
                    _this.folderNameList.push(folderNameList[i]);
                }
            }
        });
    };
    /** action on click of naac reTeam tab
    * @class NaacComponent
    * @method naacReTeam
    */
    NaacComponent.prototype.naacReTeam = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.isNewsPageClicked = false;
        this.isResourcePageClicked = false;
        this.isRegionalPageClicked = true;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.affinityUpdate = false;
        this.errorAffinity = false;
        this.deleteAffinity = false;
        this.naacPublishSuccess = false;
        this.naacDetailsUpdate = false;
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.naacNewsTable = false;
        this.naacResourceTable = false;
        this.naacReTeamTable = true;
        this.affinityTable = false;
        // this.noResourceTable = false;
        // this.noNewsTable = false;
        // this.noAffinityTable = false;
        this.naacDetailsSuccess = false;
        this.naacNewsSuccess = false;
        this.naacReteamSuccess = false;
        this.naacDetailsUpdate = false;
        this.naacResourceSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.errorMessageResourceActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        // this.getnaacREteam();
    };
    /** action on click of naac dashboard tab
  * @class NaacComponent
  * @method naacReTeam
  */
    NaacComponent.prototype.naacDashboard = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.isNewsPageClicked = false;
        this.isResourcePageClicked = false;
        this.isRegionalPageClicked = false;
        this.affinitySuccess = false;
        this.affinityUpdate = false;
        this.naacDetailsUpdate = false;
        this.errorAffinity = false;
        this.deleteAffinity = false;
        this.naacPublishSuccess = false;
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.naacNewsTable = false;
        this.naacResourceTable = false;
        this.naacReTeamTable = false;
        this.affinityTable = false;
        // this.noResourceTable = false;
        // this.noNewsTable = false;
        // this.noReginalTbale = false;
        // this.noAffinityTable = false;
        this.naacDetailsSuccess = false;
        this.naacNewsSuccess = false;
        this.naacReteamSuccess = false;
        this.naacResourceSuccess = false;
        this.naacDetailsUpdate = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.errorMessageResourceActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        //this.getnaacREteam();
    };
    /** get list of naac Reteam
     * @class NaacComponent
     * @method getnaacREteamList
     */
    NaacComponent.prototype.getnaacREteam = function () {
        var _this = this;
        if (this.searchTerm != null && (this.reTeamSearchKey == null || this.reTeamSearchKey == '')) {
            this.LandingPaginationDTO.searchTerm = '';
        }
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO = {
            "filter": { "naacFlag": "naacSelfService" },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": this.reTeamSearchKey,
            "size": 500,
            "sortDirection": "ASC",
            "sortProperty": "regionalOrder",
            "uid": ""
        };
        this.naacService.getnaacREteam(this.LandingPaginationDTO).subscribe(function (data) {
            _this.naacReTeamList = data.content;
            if (_this.naacReTeamList.length == 0) {
                _this.noReginalTbale = true;
                _this.tableShow = true;
            }
            else {
                _this.noReginalTbale = false;
                _this.selectedReteam = [];
                for (var a = 0; a < _this.naacReTeamList.length; a++) {
                    if (_this.naacId == _this.naacReTeamList[a].naacId) {
                        _this.selectedReteam.push(_this.naacReTeamList[a]);
                    }
                }
            }
            if (_this.selectedReteam.length == 0) {
                _this.noReginalTbale = true;
            }
            _this.numberOfElements = _this.selectedReteam.length;
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsReTeam = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsReTeam = _this.numberOfElements;
            }
        });
        this.spinnerService.hide();
    };
    /** to select the user pic
     * @class NaacComponent
     * @method onUserPicSelected
     */
    NaacComponent.prototype.onUserPicSelected = function (event) {
        var _this = this;
        var files = event.target.files;
        var file = files[0];
        this.uploadFileNameUser = file.name;
        if (this.width == 400 && this.height == 400) {
            this.uploadFileExtensionUser = false;
        }
        else {
            this.uploadFileExtensionUser = true;
        }
        var image = event.target.files[0];
        var fr = new FileReader();
        fr.onload = function () {
            var img = new Image();
            img.onload = function () {
                _this.width = img.width;
                _this.height = img.height;
                if (_this.width == 400 && _this.height == 400) {
                    _this.uploadFileExtensionUser = false;
                }
                else {
                    _this.uploadFileExtensionUser = true;
                }
            };
            img.src = fr.result; // This is the data URL
        };
        fr.readAsDataURL(image);
        this.lbl = document.getElementById('filenameUserPic');
        this.lbl.innerText = this.uploadFileNameUser;
        if (files && file) {
            this.naacUserImage = "";
            var imageData_1 = '';
            var reader = new FileReader();
            if (reader.readAsBinaryString) {
                reader.onloadend = function (readerEvt) {
                    var binaryString = readerEvt.target.result;
                    imageData_1 = btoa(binaryString);
                    document.getElementById("base64textareaUser").textContent = imageData_1;
                };
                this.naacUserImage = imageData_1;
                reader.readAsBinaryString(file);
            }
            else { //IE 10 or 11
                var binary = "";
                //var reader = new FileReader();
                reader.onload = function (e) {
                    var bytes = new Uint8Array(e.target.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    //binary - readonly so assign content to another property
                    imageData_1 = btoa(binary);
                    document.getElementById("base64textareaUser").textContent = imageData_1;
                };
                this.naacUserImage = imageData_1;
                reader.readAsArrayBuffer(file);
            }
        }
    };
    /** on news page changed
      * @class NaacComponent
      * @method onNaacSelected
      */
    NaacComponent.prototype.pageNewsChanged = function (event) {
        // this.clearAlerts();
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsNews = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsNews = this.numberOfElements;
        }
        this.getnaacnewsList();
    };
    /** on news page changed
    * @class NaacComponent
    * @method pageAffinityChanged
    */
    NaacComponent.prototype.pageAffinityChanged = function (event) {
        // this.clearAlerts();
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsAffinity = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsAffinity = this.numberOfElements;
        }
        this.getnaacAffinityList();
    };
    /** on resource page changed
    * @class DIComponent
    * @method pageResourceChanged
    */
    NaacComponent.prototype.pageResourceChanged = function (event) {
        // this.clearAlerts();
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsResource = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsResource = this.numberOfElements;
        }
        this.getNaacResouceList();
        this.getNaacFolderList();
    };
    /** on reTeam page changed
   * @class DIComponent
   * @method pageReteamChanged
   */
    NaacComponent.prototype.pageReteamChanged = function (event) {
        // this.clearAlerts();
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsReTeam = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsReTeam = this.numberOfElements;
        }
        this.getnaacREteam();
    };
    /** on naac page changed
   * @class DIComponent
   * @method pageNaacChanged
   */
    NaacComponent.prototype.pageNaacChanged = function (event) {
        // this.clearAlerts();
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsNaac = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsNaac = this.numberOfElements;
        }
        // this.getNaacList();
    };
    /** For searching the user
   * @class NaacComponent
   * @method searchBy
   */
    NaacComponent.prototype.searchBy = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.search = true;
        this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
        this.LandingPaginationDTO.searchTerm = this.searchTerm;
        this.getUserList();
        this.spinnerService.hide();
    };
    /** For searching the news
   * @class DIComponent
   * @method searchNewsMe
   */
    NaacComponent.prototype.searchNewsMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.newsSearchKey = (this.newsSearchKey) ? this.newsSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.newsSearchKey;
        this.currentPage = 1;
        this.getnaacnewsList();
        this.spinnerService.hide();
    };
    /** For searching the resource
   * @class NaacComponent
   * @method searchResourceMe
   */
    NaacComponent.prototype.searchResourceMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.resourceSearchKey = (this.resourceSearchKey) ? this.resourceSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.resourceSearchKey;
        this.currentPage = 1;
        this.getNaacResouceList();
        this.getNaacFolderList();
        this.spinnerService.hide();
    };
    /** For searching the reTeam
   * @class DIComponent
   * @method searchReTeamMe
   */
    NaacComponent.prototype.searchReTeamMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.reTeamSearchKey = (this.reTeamSearchKey) ? this.reTeamSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.reTeamSearchKey;
        this.currentPage = 1;
        this.getnaacREteam();
        this.spinnerService.hide();
    };
    /** to Delete naac
  * @class NaacComponent
  * @method deleteNaac
  */
    NaacComponent.prototype.deleteNaac = function (id, flag, i) {
        //this.clearAlerts();
        document.getElementById('deleteNaac' + i).setAttribute('data-toggle', 'modal');
        document.getElementById('deleteNaac' + i).setAttribute('data-target', '#myModal');
        this.method = "deleteAllNaac";
        this.param = id;
        this.param1 = flag;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    NaacComponent.prototype.deleteAllNaac = function (id, flag) {
        var _this = this;
        var dleteData = {
            "id": id,
            "flag": flag
        };
        this.naacService.deletenaac(dleteData).subscribe(function (data) {
            if (data.flag == "news") {
                _this.deleteNews = true;
                _this.deleteResetNews();
                _this.getnaacnewsList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else if (data.flag == "resource") {
                _this.deleteResource = true;
                _this.deleteResetResource();
                _this.getNaacResouceList();
                _this.getNaacFolderList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else if (data.flag == "regional") {
                _this.deleteRegional = true;
                _this.deleteResetReTeam();
                _this.getnaacREteam();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else {
                //this.deleteNaac = true;
                // this.deleteResetNaac();
                // this.getNaacList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
        });
    };
    /** to edit news
  * @class DIComponent
  * @method editNaac
  */
    NaacComponent.prototype.editNaac = function (data) {
        this.method = "onEditNaacClick";
        this.param = data;
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    NaacComponent.prototype.onEditNaacClick = function (data) {
        this.resetDashboard();
        this.onResetnaacDetails();
        this.onResetNewsClick();
        this.onResetResourceClick();
        this.onResetReTeamClick();
        this.selectedNews = [];
        this.selectedReteam = [];
        this.selectedResource = [];
        this.naacEdit = true;
        this.naacId = data.naacId;
        localStorage.setItem("naacId", this.naacId);
        if (data.naacId != null) {
            //dashboard section
            this.selectedBpg = data.naacAffinityId;
            this.naacDate = data.naacDate ? new Date(data.naacDate.replace('-', '/')) : null;
            //details section
            if (this.bannerResponseList.length > 0) {
                for (var b = 0; b < this.bannerResponseList.length; b++) {
                    if (data.naacId == this.bannerResponseList[b].naacId) {
                        this.isbannerimageLoaded = true;
                        this.naacVision = this.bannerResponseList[b].naacVision;
                        this.naacAffinity = this.bannerResponseList[b].naacAffinity;
                        this.uploadFileNameBanner = this.bannerResponseList[b].naacBanner;
                        this.naacBannerId = this.bannerResponseList[b].naacBannerId;
                        document.getElementById("filenamenaacLogo").textContent = this.bannerResponseList[b].naacLogo;
                        this.uploadnaacLogoDone = false;
                        this.naacLogo = this.bannerResponseList[b].naacLogo;
                        this.uploadFileNamenaacLogo = this.bannerResponseList[b].naacLogo;
                    }
                }
            }
            //news section
            if (this.naacNewsList.length > 0) {
                for (var j = 0; j < this.naacNewsList.length; j++) {
                    if (data.naacId == this.naacNewsList[j].naacId) {
                        this.selectedNews.push(this.naacNewsList[j]);
                    }
                }
            }
            //RE Team
            if (this.naacReTeamList.length > 0) {
                for (var a = 0; a < this.naacReTeamList.length; a++) {
                    if (data.naacId == this.naacReTeamList[a].naacId) {
                        this.selectedReteam.push(this.naacReTeamList[a]);
                    }
                }
            }
            // Resource Team
            if (this.naacResouceList.length > 0) {
                for (var z = 0; z < this.naacResouceList.length; z++) {
                    if (data.naacId == this.naacResouceList[z].naacId) {
                        this.selectedResource.push(this.naacResouceList[z]);
                    }
                }
            }
        }
    };
    /** to delete news Image
     * @class naacComponent
     * @method removeFile
     */
    NaacComponent.prototype.removeFile = function () {
        this.isUploadnewsImage = false;
        document.getElementById("filenamenewsImage").textContent = "JPEG or PNG";
        document.getElementById("base64textareanewsImage").textContent = '';
        this.uploadFileNamenewsImage = null;
        this.isLoadernewsImageStop = false;
        this.naacNewsImage = '';
        this.uploadnewsImageDone = true;
        this.uploadFileExtensionNewsImage = false;
        this.imageCheck = false;
    };
    /** to delete full naac
  * @class naacComponent
  * @method naacDelete
  // */
    NaacComponent.prototype.OnnaacDeleteConfirmation = function (naacId) {
        this.method = "naacDelete";
        this.param = naacId;
        this.msg1 = " Are you sure you want to delete the NAAC? ";
    };
    NaacComponent.prototype.naacDelete = function (naacId) {
        var _this = this;
        this.spinnerService.show();
        this.naacService.deleteNaacAffinity(naacId).subscribe(function (data) {
            _this.spinnerService.hide();
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            _this.deleteAffinity = true;
            _this.resetDashboard();
            _this.onResetnaacDetails();
            _this.onResetNewsClick();
            _this.onResetResourceClick();
            _this.onResetReTeamClick();
            _this.getnaacAffinityList();
        });
    };
    /** to edit news
  * @class DIComponent
  * @method editNews
  */
    NaacComponent.prototype.editNews = function (data, i) {
        if (this.newsTitle != null || this.newsLink != null) {
            this.firstEditNews = false;
        }
        if (this.firstEditNews == true) {
            this.firstEditNews = false;
            this.editNewsData(data);
        }
        else {
            document.getElementById('editN' + i).setAttribute('data-toggle', 'modal');
            document.getElementById('editN' + i).setAttribute('data-target', '#myModal');
            this.method = "editNewsData";
            this.param = data;
            this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
        }
    };
    NaacComponent.prototype.editNewsData = function (data) {
        this.newsTitle = data.naacNewsTitle;
        this.newsDesc = data.naacNewsDesc;
        this.newsLink = data.naacNewsLink;
        this.newsId = data.naacNewsId;
        //this.isUploadnewsImage = data.naacImageCheck;
        this.imageCheck = data.naacImageCheck;
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveNews = false;
        this.saveAndUpdateNews = true;
        this.naacNewsSuccess = false;
        document.getElementById("filenamenewsImage").textContent = data.naacNewsName.length > 13 ? data.naacNewsName.substring(13) : 'JPEG or PNG';
        //this.uploadnewsImageDone = data.naacImageCheck;
    };
    /** to edit resource
    * @class DIComponent
    * @method editResource
    */
    NaacComponent.prototype.editResource = function (data, i) {
        if (this.addResouceTitle != null || this.addResourceDocument != null) {
            this.firstEditResource = false;
        }
        if (this.firstEditResource == true) {
            this.firstEditResource = false;
            this.editResourceData(data);
        }
        else {
            document.getElementById('editR' + i).setAttribute('data-toggle', 'modal');
            document.getElementById('editR' + i).setAttribute('data-target', '#myModal');
            this.method = "editResourceData";
            this.param = data;
            this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
        }
    };
    NaacComponent.prototype.editResourceData = function (data) {
        this.errorMsgUploadSaveUpdate = false;
        this.errorMsgUploadSave = false;
        this.isFileUploded = true;
        this.addResouceTitle = data.naacResourceTitle;
        this.additionalDesc = data.naacResourceDesc;
        this.ResourcefileName = data.naacResourceDocument;
        this.resourceOrder = data.resourceOrder;
        this.naacResourceId = data.naacResourceId;
        this.selectedFile = null;
        this.UploadDocument = data.naacResourceDocument;
        this.selectedFolder = data.folderId;
        this.folderName = data.folderName;
        this.folderId = data.folderId;
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveResource = false;
        this.saveAndUpdateResource = true;
        this.naacResourceSuccess = false;
    };
    /** to edit reTeam
    * @class DIComponent
    * @method editReTeam
    */
    NaacComponent.prototype.editReTeam = function (data, i) {
        // this.clearAlerts();
        if (this.regionalDesignation != null || this.emailId != null) {
            this.firstEditReTeam = false;
        }
        if (this.firstEditReTeam == true) {
            this.firstEditReTeam = false;
            this.editReTeamData(data);
        }
        else {
            document.getElementById('editRt' + i).setAttribute('data-toggle', 'modal');
            document.getElementById('editRt' + i).setAttribute('data-target', '#myModal');
            this.method = "editReTeamData";
            this.param = data;
            this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
        }
    };
    NaacComponent.prototype.editReTeamData = function (data) {
        this.butDisabled = false;
        this.noUser = false;
        this.userFound = false;
        this.showReset = true;
        this.searchTerm = null;
        this.RePic = document.getElementById('filenameUserPic');
        this.uploadFileNameUser = data.userPic;
        if (this.uploadFileNameUser != null && this.uploadFileNameUser != undefined && this.uploadFileNameUser.trim() != "") {
            var b = this.uploadFileNameUser;
            this.RePic.innerText = b;
        }
        this.naacUserImage = '';
        this.userFirstName = data.userName;
        this.regionalDesignation = data.roleName;
        this.emailId = data.emailId;
        this.userPic = data.userPic;
        this.reTeamOrder = data.regionalOrder;
        this.naacReTeamId = data.naacReTeamId;
        this.userId = data.userId;
        this.naacPronoun = data.naacPronounce;
        if (data.siteName.length > 0) {
            this.siteName = data.siteNameList;
        }
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveReTeam = false;
        this.saveAndUpdateReTeam = true;
        this.naacReteamSuccess = false;
    };
    /** link validation
  * @class DIComponent
  * @method onLinkType
  */
    NaacComponent.prototype.onLinkType = function (event, type) {
        var re = /^(http[s]?:\/\/){0,1}(www.\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        if (re.test(String(event.target.value).toLowerCase()) == false) {
            if (type == 'news') {
                if (event.target.value != "") {
                    this.newsLinkValid = true;
                }
            }
        }
        else {
            if (type == 'news') {
                this.newsLinkValid = false;
            }
        }
    };
    /** email validation
  * @class NaacComponent
  * @method onEmailType
  */
    NaacComponent.prototype.onEmailType = function (event) {
        var re = /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/;
        if (re.test(String(event.target.value).toLowerCase()) == false) {
            if (this.butDisabled == false) {
                this.reTeamEamilValid = true;
            }
        }
        else {
            this.reTeamEamilValid = false;
        }
    };
    /** checks if word exists in array
   * @class ConfigureGalleryComponent
   * @method isInArray
   */
    NaacComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    NaacComponent.prototype.onFileSelectedBanner = function (event) {
        if (event.target.files.length > 0) {
            this.isUploadBannerImage = true;
            this.isLoaderBannerStop = true;
            this.imageChangedEventBanner = event;
            this.imageTypeName = 'bannerImage';
            this.selectedFileforBanner = null;
            //this.fileExtensionCount = 0;
            this.fileSizeExtensionError = false;
            this.deleteSuccess = false;
            if (event.target.files[0].type != "image/png" && (event.target.files[0].type != "image/jpeg"))
                this.bannerImageExtensionError = true;
            if (event.target.files[0].type == "image/png" || event.target.files[0].type == "image/jpeg") {
                this.bannerImageExtensionError = false;
                this.selectedFileforBanner = event.target.files[0];
                this.uploadFileNameBanner = this.selectedFileforBanner.name;
            }
        }
    };
    /** on resource file selected
  * @class DIComponent
  * @method onFileSelected
  */
    NaacComponent.prototype.onFileSelected = function (event) {
        this.isFileUploded = true;
        if (event.target.files.length > 0) {
            this.ResourcefileName = event.target.files[0].name;
            this.fileSize = event.target.files[0].size;
            this.fileExtension = this.ResourcefileName.split('.').pop();
            if (this.fileSize >= 524288000) {
                this.fileSizeExtensionError = true;
            }
            else {
                this.fileSizeExtensionError = false;
                this.selectedFile = event.target.files[0];
                this.UploadDocument = this.selectedFile.name;
            }
        }
    };
    NaacComponent.prototype.fileChangeEvent = function (event, imageType) {
        var _this = this;
        var files = event.target.files;
        var file = files[0];
        this.imageTypeName = imageType;
        if (file.type !== "image/png" && file.type !== "image/jpeg") {
            if (this.imageTypeName == 'userPic') {
                this.uploadFileExtensionUser = true;
                this.myInputVariable.nativeElement.value = '';
            }
            else if (this.imageTypeName == 'bannerImage') {
                this.uploadFileExtension = true;
                this.myInputBannerVariable.nativeElement.value = '';
            }
            else if (this.imageTypeName == 'naacLogo') {
                this.uploadFileExtensionnaacLogo = true;
            }
            else if (this.imageTypeName == 'newsImage') {
                this.uploadFileExtensionNewsImage = true;
            }
            else {
                // do nothing
            }
        }
        else {
            this.imageChangedEvent = event;
            if (this.imageTypeName == 'userPic') {
                this.uploadFileExtensionUser = false;
                this.uploadFileNameUser = file.name;
                document.getElementById("filenameUserPic").textContent = this.uploadFileNameUser;
                this.isLoaderUserPicStop = false;
                this.uploadUserPicImageDone = true;
                this.isUploadUserPicImage = true;
            }
            else if (this.imageTypeName == 'bannerImage') {
                //this.uploadFileName = file.name;
                this.uploadFileExtension = false;
                //document.getElementById("filenameBanner").textContent = this.uploadFileName;
                this.isLoaderStop = false;
                this.uploadImageDone = true;
                this.isUploadImage = true;
            }
            else if (this.imageTypeName == 'naacLogo') {
                this.uploadFileNamenaacLogo = file.name;
                this.isLoaderNaacLogoStop = false;
                this.uploadFileExtensionnaacLogo = false;
                this.isUploadnaacLogoImage = true;
                this.uploadnaacLogoDone = true;
                document.getElementById("filenamenaacLogo").textContent = this.uploadFileNamenaacLogo;
            }
            else if (this.imageTypeName == 'newsImage') {
                this.uploadFileNamenewsImage = file.name;
                this.isUploadnewsImage = true;
                this.isLoadernewsImageStop = false;
                this.uploadFileExtensionNewsImage = false;
                this.uploadnewsImageDone = true;
                document.getElementById("filenamenewsImage").textContent = this.uploadFileNamenewsImage;
                if (event.target.files && event.target.files.length) {
                    var reader_1 = new FileReader();
                    reader_1.readAsDataURL(file);
                    reader_1.onload = function () {
                        var img = new Image();
                        img.src = reader_1.result;
                        img.onload = function () {
                            _this.newsImageHeight = img.naturalHeight.toString();
                            _this.newsImageWidth = img.naturalWidth.toString();
                        };
                    };
                }
            }
            else {
                //do nothing
            }
        }
    };
    NaacComponent.prototype.imageCropped = function (event) {
        this.croppedImage = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
        if (this.imageTypeName == 'userPic') {
            document.getElementById("base64textareaUser").textContent = this.croppedImage;
            this.naacUserImage = this.croppedImage;
            this.uploadUserPicImageDone = true;
        }
        else if (this.imageTypeName == 'bannerImage') {
            this.naacBannerImage = this.croppedImage;
        }
        else if (this.imageTypeName == 'naacLogo') {
            document.getElementById("base64textareanaacLogo").textContent = this.croppedImage;
            this.naacLogoImage = this.croppedImage;
            this.uploadnaacLogoDone = true;
        }
        else if (this.imageTypeName == 'newsImage') {
            this.naacNewsImage = this.croppedImage;
            document.getElementById("base64textareanewsImage").textContent = this.croppedImage;
            this.uploadnewsImageDone = true;
        }
        else {
            //do nothing
        }
    };
    NaacComponent.prototype.imageLoaded = function () {
        if (this.imageTypeName == 'userPic') {
            this.isLoaderUserPicStop = true;
        }
        else if (this.imageTypeName == 'bannerImage') {
            this.isLoaderBannerStop = true;
        }
        else if (this.imageTypeName == 'newsImage') {
            this.isLoadernewsImageStop = true;
        }
        else if (this.imageTypeName == 'naacLogo') {
            this.isLoaderNaacLogoStop = true;
        }
        else {
            //do nothing
        }
        // show cropper
    };
    NaacComponent.prototype.cropperReady = function () {
        // cropper ready
    };
    NaacComponent.prototype.loadImageFailed = function () {
        // show message
    };
    NaacComponent.prototype.cancelUploadedImage = function (imageType) {
        if (imageType == 'userPic') {
            document.getElementById("base64textareaUser").textContent = '';
            document.getElementById("filenameUserPic").textContent = "JPEG or PNG";
            this.myInputVariable.nativeElement.value = '';
            this.uploadFileExtensionUser = false;
            this.naacUserImage = null;
            this.uploadFileNameUser = null;
            this.isUploadUserPicImage = false;
            this.isLoaderUserPicStop = false;
            ;
        }
        else if (imageType == 'bannerImage') {
            this.isUploadBannerImage = false;
            this.bannerImageExtensionError = false;
            this.isLoaderBannerStop = false;
            this.imageChangedEventBanner = '';
            this.uploadFileNameBanner = 'JPEG or PNG';
            this.isbannerimageLoaded = false;
        }
        else if (imageType == 'newsImage') {
            this.isUploadnewsImage = false;
            document.getElementById("filenamenewsImage").textContent = "JPEG or PNG";
            document.getElementById("base64textareanewsImage").textContent = '';
            this.uploadFileNamenewsImage = null;
            this.isLoadernewsImageStop = false;
            this.naacNewsImage = '';
            this.uploadnewsImageDone = true;
            this.uploadFileExtensionNewsImage = false;
        }
        else if (imageType == 'naacLogo') {
            this.isLoaderNaacLogoStop = false;
            this.uploadFileExtensionnaacLogo = false;
            this.naacLogoImage = '';
            this.isUploadnaacLogoImage = false;
            this.uploadFileNamenaacLogo = null;
            this.uploadnaacLogoDone = true;
            document.getElementById("filenamenaacLogo").textContent = 'JPEG or PNG';
            document.getElementById("base64textareanaacLogo").textContent = '';
        }
        else {
            //do nothing
        }
        this.imageChangedEvent = '';
        this.croppedImage = '';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    };
    NaacComponent.prototype.doneUploadedImage = function (imageType) {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        if (imageType == 'userPic') {
            this.myInputVariable.nativeElement.value = '';
            this.uploadFileExtensionUser = false;
            this.uploadUserPicImageDone = false;
            this.isLoaderUserPicStop = false;
            this.isUploadUserPicImage = false;
        }
        else if (imageType == 'bannerImage') {
            this.isUploadBannerImage = false;
            this.isLoaderBannerStop = false;
            this.isbannerimageLoaded = true;
            this.isLoaderStop = false;
            this.bannerImageExtensionError = false;
        }
        else if (imageType == 'newsImage') {
            this.isUploadnewsImage = false;
            this.isLoadernewsImageStop = false;
            this.uploadFileExtensionNewsImage = false;
            this.uploadnewsImageDone = false;
            this.uploadFileExtensionNewsImage = false;
        }
        else if (imageType == 'naacLogo') {
            this.myInputVariable.nativeElement.value = '';
            this.isLoaderNaacLogoStop = false;
            this.uploadFileExtensionnaacLogo = false;
            this.isUploadnaacLogoImage = false;
            this.uploadnaacLogoDone = false;
        }
        else {
            // do nothing
        }
    };
    return NaacComponent;
}());
export { NaacComponent };
